import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Category } from '@core/interfaces';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { CategoryService } from '@app/core/services';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() selectedCategory: Category;
  @Input()isInSection: boolean;
  public categoryList: Array<Category> = [];
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private categoryService: CategoryService,
    
  ) { }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.getCategories();
  }

  public searchForm: FormGroup = new FormGroup({
    categoryId: new FormControl(null),
    name: new FormControl(null),
    country: new FormControl(null),
    appointmentDate: new FormControl(null),
    pageIndex: new FormControl(1),
    pageSize: new FormControl(5),
  });

  selectCategory(cat: Category): void {
    this.selectedCategory = cat;
    this.searchForm.get('categoryId').setValue(cat ? cat.id : null);
  }

  searchBusiness() {
    const data = {
      categoryId: this.searchForm.value.categoryId,
      name: this.searchForm.value.name,
      country: this.searchForm.value.country,
      appointmentDate: this.searchForm.value.appointmentDate,
    };
    data.appointmentDate && (data.appointmentDate = data.appointmentDate.toISOString());
    this.router.navigate(['/business-services/search'], { queryParams: data });
  }


  getCategories(): void {
    this.categoryService.GetAll()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: res => {
          this.categoryList = res;
          if (this.searchForm.value.categoryId) {
            this.selectedCategory = this.categoryList.find(c => c.id === this.searchForm.value.categoryId);
          }
        }
      });
  }

}
